import DashboardComponentWrapper from "../../components/dashboard/DashboardComponentWrapper";

export default function CardPaymentTerms() {

  return (
    <DashboardComponentWrapper
      subTitle={``}
      pageDetails=""
    >
      <div className="">Card Terms and Conditions</div>
    </DashboardComponentWrapper>
  )
}